import { createFileRoute } from "@tanstack/react-router";

import LeagueProfile from "@/components/LeagueProfile/LeagueProfile";

const Component = () => {
  const { leagueUuid } = Route.useParams();
  return <LeagueProfile leagueUuid={leagueUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/events/series/$leagueUuid/profile")({
  component: Component,
});
